import { render } from "./collectList.vue?vue&type=template&id=73b8fd08"
import script from "./collectList.vue?vue&type=script&lang=js"
export * from "./collectList.vue?vue&type=script&lang=js"

import "./collectList.vue?vue&type=style&index=0&id=73b8fd08&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__